export default __webpack_public_path__ + "d7ea6db6a2f7308c8fe3b90d1c31e74a.png";